import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, objectSpread2 as _objectSpread2, asyncToGenerator as _asyncToGenerator, createClass as _createClass } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../../node_modules/prop-types/index.js';
import React from 'react';
import { connect } from 'react-redux';
import { compareParams } from '../../../modules/utility/params.js';
import { abortableApi } from '../../../modules/abort/actions.js';

var ContentBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentBase, _React$Component);

  var _super = _createSuper(ContentBase);

  function ContentBase(_props) {
    var _this;

    _classCallCheck(this, ContentBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultCommonState", function () {
      return {
        error: undefined
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultDataState", function (props) {
      return {
        data: props.initialData,
        loading: false,
        slowLoading: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultInitialState", function (props) {
      return _objectSpread2(_objectSpread2({}, _this.defaultCommonState()), _this.defaultDataState(props));
    });

    _defineProperty(_assertThisInitialized(_this), "defaultResetState", function (props) {
      var resetData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _objectSpread2(_objectSpread2({}, _this.defaultCommonState()), resetData ? _this.defaultDataState(props) : {});
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (!compareParams(_this.props.loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, _data, loadResponse, loadingKey, loadingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, loadAction = _this$props.loadAction, loadParams = _this$props.loadParams, loadTransform = _this$props.loadTransform, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch;

              if (onLoad) {
                _data = onLoad(loadParams);

                _this.setState({
                  data: _data
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 21;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 11;
              return dispatch(loadingAction);

            case 11:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  data: loadResponse
                });
              }

            case 21:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onReset", function () {
      var defaultState = _this.defaultResetState(_this.props);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), defaultState);
      }, _this.loadData);
    });

    _defineProperty(_assertThisInitialized(_this), "onRefresh", function () {
      var defaultState = _this.defaultResetState(_this.props, false);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), defaultState);
      }, _this.loadData);
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    return _this;
  }

  _createClass(ContentBase, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          error = _this$state.error,
          data = _this$state.data;
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        error: error,
        initialData: this.props.initialData
      };
      var events = {
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onAbortLoad: this.onAbortLoad
      };
      return this.props.render(data, state, events);
    }
  }]);

  return ContentBase;
}(React.Component);

_defineProperty(ContentBase, "propTypes", {
  initialData: _pt.any.isRequired,
  loadAction: _pt.func,
  loadParams: _pt.any,
  loadTransform: _pt.func.isRequired,
  loadSlowDelay: _pt.number.isRequired,
  onLoad: _pt.func,
  onLoaded: _pt.func,
  render: _pt.func.isRequired,
  dispatch: _pt.any.isRequired
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase = function connectBase() {
  return connect(null, mapDispatchToProps)(ContentBase);
};

var ContentBaseComponent = connectBase();

var ContentBase$1 = function ContentBase$1(props) {
  return /*#__PURE__*/React.createElement(ContentBaseComponent, props);
};

export { ContentBase$1 as default };
